import { parseISO, add as addDate, formatISO } from "date-fns";

export function getPercChange(start, end) {
  if (start === 0) {
    return null;
  }
  
  return ((end - start) / start) * 100;
}

export function getDaysBetween(start, end) {
  const endDate = parseISO(end);
  let currentDate = parseISO(start);
  let dates = [];

  while (currentDate <= endDate) {
    dates.push(formatISO(currentDate, { representation: "date" }));

    currentDate = addDate(currentDate, {
      days: 1
    });
  }

  return dates;
}

export function formatDateISO(date) {
  return formatISO(date, { representation: "date" });
}


export function getDataRange(accesor, data) {
  let maxValue = -Number.MAX_VALUE;
  let minValue = Number.MAX_VALUE;

  for (let element of data) {
    const elementData = accesor(element);
    if (elementData > maxValue) {
      maxValue = elementData;
    }
    if (elementData < minValue) {
      minValue = elementData;
    }
  }

  return [minValue, maxValue];
}